module.exports = __webpack_public_path__ + "img/17csm_Ersa-VERSAFLOW-ONE-Features-01-900x600_48154883b2.e92dddd9.jpg";